<template>
  <div class="equity_layout">
    <div class="equity_body">
      <div v-if="this.regionNo === '37'" class="equity_body_content">
        <!-- 顶级标题 -->
        <h1>山东惠享网购-权益业务说明</h1>
        <!-- 产品服务内容 -->
        <div class="equity_body_content_middle">
          <strong>产品服务内容：</strong>
          <p>本产品权益包含：京东超市京东E卡，天猫超市电子券，中萃到家(中粮)电子券，屈臣氏
            E-Fun卡，唯品会唯品卡等优惠券服务。用户每月可任选其一使用，当月未选用权益即失效(不延续至次月)，次月可按需更换权益，所选权益包有效期内均需主动领取，已领取不可变更、退还，未领取不可补领、补发：平台权益领取后，相应优惠券将直充至订购权益的手机号码，所注册的客户端账户中。</p>
          <ul>
            <li>
              <strong>京东超市京东E卡：</strong>
              每月选用1次，2张10元京东超市京东E卡，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取且不可补发。领取权益前，请先确认本权益订购号码是否注册京东账户，如未注册，请先注册账户后再领取该权益。领取成功后，权益将直充至订购手机号码所绑定的账号。仅限京东商城APP，微信小程序移动端使用；在京东超市购物支付时支持使用该电子券抵扣付款。
            </li>
            <li>
              <strong>天猫超市电子券：</strong>
              每月选用1次，2张10元天猫超市电子券，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取且不可补发。领取权益前，请先确认本权益订购号码是否注册天猫/淘宝账户，如未注册，请先注册账户后再领取该权益。领取时需输入与订购手机号码绑定的常用天猫/淘宝账号（此天猫/淘宝账户只能被一个订购手机号码所绑定，确定后账号90天只允许更改一次）。领取成功后，权益将直充至订购手机号码所绑定的账号。仅限天猫超市中网购使用；天猫，淘宝APP与电脑端天猫超市支持使用该电子券抵扣付款。
            </li>
            <li>
              <strong>中萃到家(中粮)电子券：</strong>
              每月可选，2张10元中萃到家电子券，每隔7天可领用1张，领用后30天内有效；在中萃到家微信小程序购买商品时，可使用该电子券抵扣付款。
            </li>
            <li>
              <strong>屈臣氏E-Fun卡：</strong>
              每月可选，2张10元屈臣氏E-Fun卡，每隔7天可领用1张，领用后30天内有效，过期无法领取且不可补发；领取权益前，请先确认本权益订购号码是否注册屈臣氏账户，如未注册，请先注册账户后再领取该权益。领取成功后，权益将直充至订购手机号码所绑定的账号。在屈臣氏全国线下实体门店，屈臣氏云店(微信小程序)，屈臣氏APP均可使用(保税仓跨境购商品不可用E-Fun卡抵扣)该电子券抵扣付款。
            </li>
            <li>
              <strong>唯品会唯品卡：</strong>
              每月选用1次，2张10元唯品会唯品卡，每隔7天可用领用1张，从领用第1张时间开始计算第2张30天领用有效期，过期无法领取且不可补发。领取权益前，请先确认本权益订购号码是否注册唯品会账户，如未注册，请先注册账户后再领取该权益。领取成功后，权益将直充至订购手机号码所绑定的账号。在唯品会APP/微信小程序“唯品会特卖”上使用，支持线下唯品会城市奥莱、线下门店使用POS机结账应用购物支付时，支持使用该电子券抵扣付款。
            </li>
          </ul>
        </div>
        <!-- 注释内容 -->
        <div class="equity_body_content_footer">
          <strong>备注：关于后期如涉及权益内容变更的说明：</strong>
          <ul>
            <li>
              1、因权益方内部调整，权益平台可能会变更，终止与权益方的合作，并在权益服务页面发布公告告知变更内容。如因此导致您无法使用，领取或购买权益，请您理解权益平台无须对此承担责任。届时您可选择领取其他权益方提供的权益，可能给您带来的不便，敬请谅解。
            </li>
            <li>
              2、山东电信可能会根据本服务的整体规划，对本服务相关权益细则，收费标准，权益发放方式等进行修改或变更；前述修改，变更的内容，山东电信将在相应权益服务页面或以其它合理方式进行告知，并在告知后生效。当您采用接受服务的形式(包括但不限于支付行为，未退定继续使用本服务等)，即表明您已经了解并接受本服务的全部修改，以及上述服务细则的修改和变更
            </li>
            <li>3、本产品最终解释权归山东电信所有。</li>
          </ul>
        </div>
  </div>
  <div v-if="this.regionNo === '41'" class="equity_body_content">
    <!-- 顶级标题 -->
    <h1>河南惠享网购-权益业务说明：</h1>
    <!-- 产品服务内容 -->
    <div class="equity_body_content_middle">
      <strong>产品服务内容:</strong>
      <p>
        本产品权益包含：中萃到家电子券、天猫超市电子券、京东超市京东E卡、三项优惠券服务（中萃到家电子券为必选券），其他两种，用户每月可任选其一使用，次月可按需更换：
      </p>
      <ul>
        <li>
          <strong>中萃到家电子券：</strong>
          每月领用激活1次，1张10元或20元超市电子券，仅限中萃到家小程序中网购使用；在中萃到家购物支付时，可使用中萃到家的金额抵扣付款。
        </li>
        <li>
          <strong>天猫超市电子券：</strong>
          每月选用1-2张10元天猫超市电子券（根据资费确认次数）。仅限天猫超市中网购使用；天猫、淘宝APP与电脑端天猫超市支持使用该电子券抵扣付款。
        </li>
        <li>
          <strong>京东超市京东E卡：</strong>
          每月选用1-2张10元京东E卡电子券（根据资费确认次数）。仅限京东商城APP/小程序移动端网购使用；在京东购物支付时，可使用京东E卡的金额抵扣付款。
        </li>
      </ul>
    </div>

    <!-- 注释内容 -->
    <div class="equity_body_content_footer">
      <p>
        注：以上中萃到家电子券、天猫超市电子券、京东E卡、三大权益（中萃到家电子券为必选券）外，另两种券每月可任选其一或其二，
        确定使用本月的一项权益后，剩余的其它一项权益自动失效；下月可重新选择。
      </p>
      <strong>备注：关于后期如涉及权益内容变更的说明：</strong>
      <li>
        1、因权益方内部调整，权益平台可能会变更、终止与权益方的合作，并在权益服务页面发布公告告知变更内容。如因此导致您无法使用、领取或购买权益，请您理解权益平台无须对此承担责任。届时您可选择领取其他权益方提供的权益，可能给您带来的不便，敬请谅解。
      </li>
      <li>
        2、山东电信可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、权益发放方式等进行修改或变更；前述修改、变更的内容，山东电信将在相应权益服务页面或以其它合理方式进行告知，并在告知后生效。当您采用接受服务的形式（包括但不限于支付行为、未退定继续使用本服务等），即表明您已经了解并接受本服务的全部修改，以及上述服务细则的修改和变更
      </li>
      。
      <li>3、本产品最终解释权归山东电信所有。</li>
    </div>
  </div>
  <!--      上9.9-->
  <div v-if="this.regionNo === '31' && this.spn==='SPN202501011515545157071'" class="equity_body_content">
    <div class="equity_body_content_top">
      <h1>上海惠享生活-权益业务说明</h1>
    </div>
    <div class="equity_body_content_middle">
      <p><strong>产品服务内容：</strong></p>
      <p>
        本产品权益包含：锅圈食汇电子券，唯品会唯品卡，天猫超市电子子券，京东超市京东E卡屈臣氏，沃尔玛等优惠券服务，用户每月可任选其一使用，次月可按需更换。</p>
      <ul>
        <li>
          <p><strong> 锅圈食汇电子券：</strong></p>
          <p>
            每月选用1张10元锅圈食汇电子券，仅限于支持自取及外送的大陆地区锅圈食汇门店，锅圈食汇"小程序支付时，可使用锅圈食汇电子券的金额抵扣付款。</p>
        </li>
        <li>
          <p><strong>屈臣氏E-Fun卡：</strong></p>
          <p>
            每月选用1张10元屈臣氏E-Fun卡在屈臣氏全国线下实体门店，屈臣氏云店(微信小程序)，屈臣氏APP均可使用(保税仓跨境购商品不可用Efun卡抵扣)该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>唯品会唯品卡：</strong></p>
          <p>
            每月选用1张10元唯品会唯品卡，在唯品会APP/微信小程序“唯品会特卖”上使用，支持线下唯品会城市奥莱、线下门店使用POS机结账应用购物支付时，支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>沃尔玛礼品卡：</strong></p>
          <p>每月选用1张10元沃尔玛礼品卡，仅限在沃尔玛商场自营区域（茅台、iphone、奶粉1段
            不可用）、沃尔玛APP、沃尔玛小程序及沃尔玛京东到家、美团APP指定店铺使用消费付款（山姆会员商店及山姆APP不可用）支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>天猫超市电子券：</strong></p>
          <p>每月选用1张10元天猫超市电子券，仅限于天猫超市中网购使用：天猫，淘宝
            APP与电脑端天猫超市支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>京东超市京东E卡：</strong></p>
          <p>
            每月选用1张10元京东E卡电子券，仅限京东商城APP/小程序移动端使用；在京东超市购物支付时，可使用京东E卡的金额抵扣付款。</p>
        </li>
      </ul>
    </div>
    <div class="equity_body_content_footer">
      <p><strong>注：</strong></p>
      <p>
        以上锅圈食汇电子券，唯品会唯品卡，天猫超市电子子券，京东超市京东E卡，屈臣氏，沃尔玛等优惠券，每月可任选其一，确定使用本月的一项权益后，剩余的其它几项权益自动失效；下月可重新选择。</p>
      <strong>备注：关于后期如涉及权益内容变更的说明：</strong>
      <ul>
        <li>
          1、因权益方内部调整，权益平台可能会变更、终止与权益方的合作，并在权益服务页面发布公告告知变更内容。如因此导致您无法使用、领取或购买权益，请您理解权益平台无须对此承担责任。届时您可选择领取其他权益方提供的权益，可能给您带来的不便，敬请谅解。
        </li>
        <li>
          2、山东电信可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、权益发放方式等进行修改或变更；前述修改、变更的内容，山东电信将在相应权益服务页面或以其它合理方式进行告知，并在告知后生效。当您采用接受服务的形式（包括但不限于支付行为、未退定继续使用本服务等），即表明您已经了解并接受本服务的全部修改，以及上述服务细则的修改和变更。
        </li>
        <li>3、本产品最终解释权归山东电信所有。</li>
      </ul>
    </div>
  </div>

  <!--      19.9-->
  <div v-if="this.regionNo === '31' && this.spn==='SPN202503191625038150426'|| this.spn==='SPN202511241017481149103'"
       class="equity_body_content">
    <div class="equity_body_content_top">
      <h1>上海惠享生活-权益业务说明</h1>
    </div>
    <div class="equity_body_content_middle">
      <p><strong>产品服务内容：</strong></p>
      <p>
        本产品权益包含：锅圈食汇电子券，唯品会唯品卡，天猫超市电子子券，京东超市京东E卡屈臣氏，沃尔玛等优惠券服务（中萃到家电子券为必选券），其他几种，用户每月可任选其二使用，次月可按需更换。</p>
      <ul>

        <li>
          <p><strong>中萃到家电子券：</strong></p>
          <p>
            每月领用激活1次，1张10元超市电子券，仅限中萃到家小程序中网购使用；在中萃到家购物支付时，可使用中萃到家的金额抵扣付款。</p>
        </li>
        <li>
          <p><strong>锅圈食汇电子券：</strong></p>
          <p>
            每月选用1张10元锅圈食汇电子券，仅限于支持自取及外送的大陆地区锅圈食汇门店，"锅圈食汇"小程序支付时，可使用锅圈食汇电子券的金额抵扣付款。</p>
        </li>
        <li>
          <p><strong>屈臣氏E-Fun卡：</strong></p>
          <p>
            每月选用1张10元屈臣氏E-Fun卡在屈臣氏全国线下实体门店，屈臣氏云店(微信小程序)，屈臣氏APP均可使用(保税仓跨境购商品不可用Efun卡抵扣)该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>唯品会唯品卡：</strong></p>
          <p>
            每月选用1张10元唯品会唯品卡，在唯品会APP/微信小程序“唯品会特卖”上使用，支持线下唯品会城市奥莱、线下门店使用POS机结账应用购物支付时，支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>沃尔玛礼品卡：</strong></p>
          <p>每月选用1张10元沃尔玛礼品卡，仅限在沃尔玛商场自营区域（茅台、iphone、奶粉1段
            不可用）、沃尔玛APP、沃尔玛小程序及沃尔玛京东到家、美团APP指定店铺使用消费付款（山姆会员商店及山姆APP不可用）支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>天猫超市电子券：</strong></p>
          <p>每月选用1张10元天猫超市电子券，仅限于天猫超市中网购使用：天猫，淘宝
            APP与电脑端天猫超市支持使用该电子券抵扣付款。</p>
        </li>
        <li>
          <p><strong>京东超市京东E卡：</strong></p>
          <p>
            每月选用1张10元京东E卡电子券，仅限京东商城APP/小程序移动端使用；在京东超市购物支付时，可使用京东E卡的金额抵扣付款。</p>
        </li>
      </ul>
    </div>
    <div class="equity_body_content_footer">
      <p><strong>注：</strong></p>
      <p>
        以上中萃到家电子券，锅圈食汇电子券，唯品会唯品卡，天猫超市电子子券，京东超市京东E卡，屈臣氏，沃尔玛等优惠券（中萃到家电子券为必选券外），其他几种优惠券每月可任选其二，确定使用本月的二项权益后，剩余的其它几项权益自动失效；下月可重新选择。</p>
      <strong>备注：关于后期如涉及权益内容变更的说明：</strong>
      <ul>
        <li>
          1、因权益方内部调整，权益平台可能会变更、终止与权益方的合作，并在权益服务页面发布公告告知变更内容。如因此导致您无法使用、领取或购买权益，请您理解权益平台无须对此承担责任。届时您可选择领取其他权益方提供的权益，可能给您带来的不便，敬请谅解。
        </li>
        <li>
          2、山东电信可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、权益发放方式等进行修改或变更；前述修改、变更的内容，山东电信将在相应权益服务页面或以其它合理方式进行告知，并在告知后生效。当您采用接受服务的形式（包括但不限于支付行为、未退定继续使用本服务等），即表明您已经了解并接受本服务的全部修改，以及上述服务细则的修改和变更。
        </li>
        <li>3、本产品最终解释权归山东电信所有。</li>
      </ul>
    </div>
  </div>
  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      regionNo: "",
      spn: "",
    };
  },
  created() {
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const region = localStorage.getItem('regionNo'); // 从 localStorage 获取 region 标识
      this.spn = localStorage.getItem('spn');
      if (region) {
        this.regionNo = region;
      } else {
        // 如果没有标识，则可以设置默认值，或请求后端
        console.log('没有找到缓存的 region，使用默认值或请求后端');
        this.regionNo = '31'; // 例如使用 '上海' 作为默认值
      }
    }
  }

};
</script>
<style scoped lang="less">
.equity_layout {
  width: 100%;
  min-height: 100vh;
}

.equity_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .equity_body_content {
    padding: 32px;
    line-height: 1.5;
    color: #333;
    font-size: 14px;
  }

  .equity_body_content_top {
    text-indent: 2em;
  }

  .equity_body_content_middle {
    padding: 16px 0px 16px 32px;

    ul {
      list-style: disc
    }
  }

  .equity_body_content_footer {
    text-indent: 2em;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 16px;
  }
}
</style>
